import request from './services/axios.js'
// 设置精度值
export default {
  accuracy: (params) => {
    return request({
      params,
      url: '/ebook/setDpi',
      method: 'get'
    })
  },
  //自动转换精度
  rotational: (params) => {
    return request({
      params,
      url: '/cloudR/ebook/autoParse',
      method: 'post'
    })
  },
  //数字报自动转换精度
  epaperRotational: (params) => {
    return request({
      params,
      url: 'cloudR/epaper/autoParse',
      method: 'post'
    })
  },
  //获取精度
  getAccuracy: (params) => {
    return request({
      params,
      url: '/ebook/getDpi',
      method: 'get'
    })
  },
  // 是否公开展示
  isPublicDis: (params) => {
    return request({
      params,
      url: '/ebook/setBookParams',
      method: 'post'
    })
  },
  // 设置参数
  setEpaperParams: (params) => {
    const data = new URLSearchParams()
    data.append('id', params.id)
    data.append('dpi', params.dpi)
    data.append('open', params.open)
    data.append('referer', params.referer)
    data.append('displayPageNo', params.displayPageNo)
    data.append('layoutSource', params.layoutSource)
    return request.post('/ebook/epaper/setEpaperParams', data)
  }
}
